import { Button, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { helpText } from '../../../../sic-lib/types/infoData';
import { ContactPrivacyTerms } from '../../../Shared/Contact/ContactPrivacyTerms';

interface Props {
    pPolicy: boolean;
    consent: boolean;
    terms: boolean;
    dialogRef: React.MutableRefObject<HTMLDivElement | null>;
    formDispatch: React.Dispatch<Partial<{ pPolicy: boolean; consent: boolean; terms: boolean }>>;
}

export default function ContactFormConsents({
    pPolicy,
    consent,
    terms,
    dialogRef,
    formDispatch,
}: Props) {
    const { classes } = useStyles();

    const [isTermsOpen, setIsTermsOpen] = React.useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        formDispatch({ [event.target.name]: event.target.checked });
        if (event.target.name == 'pPolicy' && event.target.checked && consent === true) {
            setIsTermsOpen(true);
        }
        if (event.target.name == 'consent' && event.target.checked && pPolicy === true) {
            setIsTermsOpen(true);
        }
    };

    const handleTermsOpen = () => {
        setIsTermsOpen(!isTermsOpen);
    };

    React.useEffect(() => {
        if (isTermsOpen) {
            /* scroll to the bottom of the consent if terms is open */
            dialogRef.current && dialogRef.current.scrollTo(0, dialogRef.current.scrollHeight);
            console.log('dialogRef', dialogRef.current);
        }
    }, [isTermsOpen]);

    const getConsentValue = (value: string) => {
        switch (value) {
            case 'pPolicy':
                return pPolicy;
            case 'consent':
                return consent;
            case 'terms':
                return terms;
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item>
                <Typography variant="subtitle1">Consents</Typography>
            </Grid>
            {helpText['Consents'].map(itm =>
                itm.title === 'terms' ? (
                    <React.Fragment key={itm.title}></React.Fragment>
                ) : (
                    <Grid item key={itm.title}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={getConsentValue(itm.title)}
                                    onChange={handleChange}
                                    name={itm.title}
                                />
                            }
                            label={itm.paragraph}
                        />
                    </Grid>
                ),
            )}
            <Grid item>
                <Typography variantMapping={{ body1: 'span' }}>
                    <span style={{ color: 'red' }}>WARNING:</span> DO NOT check these boxes if you
                    don't have records of these confirmations. You agree to accept responsibility
                    for non-compliant communication practices, including fines or prosecution.
                </Typography>
            </Grid>
            <Grid item>
                <Button variant="text" onClick={handleTermsOpen}>
                    What are these?
                </Button>
            </Grid>
            {isTermsOpen && (
                <>
                    <Grid item>
                        <ContactPrivacyTerms />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Checkbox checked={terms} onChange={handleChange} name="terms" />
                            }
                            label={helpText['Consents'][2].paragraph}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paperWrapper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        paddingRight: theme.spacing(0),
        backgroundColor: theme.palette.secondary.contrastText,
        height: '250px',
        overflow: 'auto',
    },
    txtBold: {
        fontWeight: 'bold',
    },
}));
